import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  container: {
    position: 'fixed',
    width: '65vw',
    height: '95vh',
    backgroundColor: '#BDBDBD;',
  },
  title: {
    textAlign: 'center',
  },
});
export default useStyles;
